import { Icon, IconProps } from './Icon'

export const IconSunSetting01 = (props: IconProps) =>
    <Icon {...props}>
        <path
            d="M12 3v2M5.314 7.314 3.9 5.9m14.786 1.414L20.1 5.9M6 15a6 6 0 0 1 12 0m4 0H2m17 4H5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
